import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

// Supabase frequently lands the password-recovery email link on the Site URL
// root (e.g. https://site.com/#...) instead of /reset-password, with the token
// in the URL hash. This component detects that — either from the URL or from
// the PASSWORD_RECOVERY auth event — and routes the user to the reset form so
// the recovery session can be used to set a new password.
export default function PasswordRecoveryRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onResetPage = location.pathname.includes('reset-password');
    if (onResetPage) return undefined;

    // 1. Recovery token still present in the URL → go straight to the reset
    //    page, carrying the hash/query so Supabase can establish the session.
    //    We match ONLY `type=recovery` — NOT `access_token`/`code`, which also
    //    appear on a normal Google OAuth callback and must not be redirected.
    const hash = window.location.hash || '';
    const search = window.location.search || '';
    const isRecovery =
      hash.includes('type=recovery') || search.includes('type=recovery');
    if (isRecovery) {
      navigate('/reset-password' + search + hash, { replace: true });
      return undefined;
    }

    // 2. The hash may already be consumed by supabase-js before we read it, so
    //    also react to the recovery event it fires.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY' && !window.location.pathname.includes('reset-password')) {
        navigate('/reset-password', { replace: true });
      }
    });
    return () => subscription.unsubscribe();
  }, [location.pathname, navigate]);

  return null;
}
